/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_DuplicateInputs */



/**
* | output |
* | --- |
* | "Found a second subscription for this server" |
*
* @param {Activity_Billing_DuplicateInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_duplicate = /** @type {((inputs?: Activity_Billing_DuplicateInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_DuplicateInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Найдена вторая подписка на этот сервер")
	return /** @type {LocalizedString} */ ("Found a second subscription for this server")
});